export { Disclaimer } from './disclaimer.style';
